export enum EstimatesPermissions {
  GET_DEFAULT_ITEMS = 'estimates.getDefaultItems',
  MANAGE_DEFAULT_ITEMS = 'estimates.manageDefaultItems',
  MANAGE_PREFERRED_PRODUCTS = 'estimates.managePreferredProducts',

  CREATE_ESTIMATE = 'estimates.createEstimate',
  UPDATE_ESTIMATE = 'estimates.updateEstimate',
  ARCHIVE_ESTIMATE = 'estimates.archiveEstimate',
  UNARCHIVE_ESTIMATE = 'estimates.unarchiveEstimate',
  SEND_ESTIMATE = 'estimates.sendEstimate',
  DUPLICATE_ESTIMATE = 'estimates.duplicateEstimate',
}
